<template>
  <div class="value-with-label">
    <small v-if="label">{{ label }}<span>:</span></small>
    <strong>{{ formattedValue }}</strong>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import {
  formatBoolean,
  formatDate,
  formatGender,
  formatValue,
} from '@/utils/format'

const props = defineProps({
  value: {
    type: [Boolean, Date, String],
    default: null,
  },

  type: {
    type: String,
    default: 'string',
    validate: (value: string): boolean =>
      ['boolean', 'date', 'email', 'gender', 'string'].includes(value),
  },

  label: {
    type: String,
    default: null,
  },
})

const formattedValue = computed<string>((): string => {
  switch (props.type) {
    case 'boolean':
      return formatBoolean(props.value as boolean)
    case 'date':
      return formatDate(props.value as Date)
    case 'email':
      return formatValue((props.value as string)?.toLowerCase())
    case 'gender':
      return formatGender(props.value as string)
    case 'string':
    default:
      return formatValue(props.value as string)
  }
})
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/globals';

$box-shadow: 0 0 (3 * $border-width) $color-border;

.value-with-label {
  display: flex;
  flex-flow: column nowrap;
  gap: 0.5em;

  strong {
    margin: 0.125em 0;
  }
}
</style>
